import { useOnboardingContext } from './tour.controller'

export const useOnboarding = () => useOnboardingContext()
